import React from 'react';
import { VIEW_TYPES } from '../../../utils/campaignViews/index';

/**
 * ViewTypeIcon - Renders the appropriate icon for a view type
 */
const ViewTypeIcon = ({ type, size = 13 }) => {
  const props = {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
  };

  switch (type) {
    case VIEW_TYPES.FLOW:
      return (
        <svg {...props}>
          <path d="M3 3h6v6H3zM15 3h6v6h-6zM9 15h6v6H9z" />
          <path d="M6 9v3h3M18 9v6h-3M12 9v6" />
        </svg>
      );
    case VIEW_TYPES.KANBAN:
      return (
        <svg {...props}>
          <rect x="3" y="3" width="5" height="18" rx="1" />
          <rect x="10" y="3" width="5" height="12" rx="1" />
          <rect x="17" y="3" width="5" height="8" rx="1" />
        </svg>
      );
    case VIEW_TYPES.TABLE:
      return (
        <svg {...props}>
          <rect x="3" y="3" width="18" height="18" rx="2" />
          <line x1="3" y1="9" x2="21" y2="9" />
          <line x1="3" y1="15" x2="21" y2="15" />
          <line x1="9" y1="3" x2="9" y2="21" />
        </svg>
      );
    case VIEW_TYPES.GANTT:
      return (
        <svg {...props}>
          <rect x="3" y="5" width="18" height="2" rx="1" />
          <rect x="3" y="11" width="12" height="2" rx="1" />
          <rect x="3" y="17" width="15" height="2" rx="1" />
        </svg>
      );
    case VIEW_TYPES.TODOLIST:
      return (
        <svg {...props}>
          <path d="M9 11l3 3L22 4" />
          <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" />
        </svg>
      );
    case VIEW_TYPES.NEURAL:
      return (
        <svg {...props}>
          <path d="M7.5 8.5L12 12M12 12l5-4M11.8 12l.2 5.5" />
          <circle cx="7.5" cy="8.5" r="2.2" />
          <circle cx="17" cy="8" r="2.2" />
          <circle cx="12" cy="17.5" r="2.2" />
        </svg>
      );
    case VIEW_TYPES.BOARD:
      return (
        <svg {...props}>
          <rect x="4" y="5" width="16" height="14" rx="2" />
          <path d="M8 9h5M8 13h8" />
        </svg>
      );
    default:
      return null;
  }
};

export default ViewTypeIcon;
